export const companyHelpers = {
  companyStructureFromFrontToBack,
  companyStructureFromBackToFront
}
//
function companyStructureFromFrontToBack (company) {
  let newOrganization = {
    organization: {
      name: company.overview.name,
      ref: company.overview.ref,
      regNo: company.overview.regNo,
      vatNo: company.overview.vatNo,
      website: company.overview.web,
      // TODO: add also logo when BE will be ready
      // logo: this.company.overview.logo,

      address: {
        street: company.address.address.street,
        streetNo: company.address.address.streetNo,
        city: company.address.address.city,
        region: (company.address.address.region === undefined ? '' : company.address.address.region),
        country: (company.address.address.country === undefined ? '' : company.address.address.country),
        countryCode: company.address.address.countryCode,
        postalCode: company.address.address.postalCode
      },
      coordinates: company.address.coordinates
    },
    description: {
      description: company.overview.description,
      withoutStart: true
    },
    groups: {
      groups: company.overview.groups,
      withoutStart: true
    }
  }
  return newOrganization
}

// transform data structure given from Back-end to datastructure whit which Front-end work
function companyStructureFromBackToFront (company) {
  let newOrganization = {
    overview: {
      id: company.id,
      name: company.name,
      ref: company.ref,
      regNo: company.regNo,
      vatNo: company.vatNo,
      web: company.website,
      description: company.about,
      groups: (company.groups === undefined ? [] : company.groups)
    },
    address: {
      address: {
        street: company.address.street,
        streetNo: company.address.streetNo,
        city: company.address.city,
        region: company.address.region,
        country: company.address.country,
        countryCode: company.address.countryCode,
        postalCode: company.address.postalCode
      },
      coordinates: company.coordinates
    }
  }
  return newOrganization
}
